import React, { useEffect, useRef, useState } from 'react';

function TypingMessage({ message, onDone }) {
  const [displayedText, setDisplayedText] = useState('');
  const indexRef = useRef(0);

  useEffect(() => {
    if (!message) return;

    const interval = setInterval(() => {
      if (indexRef.current < message.length) {
        setDisplayedText((prev) => prev + message[indexRef.current]);
        indexRef.current += 1;
      } else {
        clearInterval(interval);
        if (onDone) onDone();
      }
    }, 50);

    return () => clearInterval(interval);
  }, [message, onDone]);

  return <p style={{ whiteSpace: 'pre-wrap' }}>{displayedText}</p>;
}

export default TypingMessage;
